import { render, staticRenderFns } from "./Garde.vue?vue&type=template&id=ecc27014"
import script from "./Garde.vue?vue&type=script&lang=ts"
export * from "./Garde.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports